module.exports = __webpack_public_path__ + "static/media/error-cross-icon-80x80.dc5f3345.svg";